import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'unseal-annual-report',
    templateUrl: './unseal-annual-report.component.html',
    styleUrls: ['./unseal-annual-report.component.scss'],
})
export class UnsealAnnualReportComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
